<template>
  <v-card class="px-12 py-10" style="max-width: 60vw" outlined>
    <h2 class="text-center" v-html="title"/>
    <v-img class="my-10" :src="resource" position="center center" max-width="350" contain/>
    <p class="text-center" v-html="description"/>
    <div class="text-center">
      <v-btn class="submit-button" @click="close">{{ $t('btnGotIt') }}</v-btn>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "FindOutSomething",
  props: {
    resource: String,
    title: String,
    description: String,
  },
  methods: {
    close() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>

</style>

